import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';

@Component({})
export default class BaseView extends Vue {
    private iframeParentCommnuicationService = new IframeParentCommnuicationService();

    public successToastPopup(message: string, headline: string = '', isDismissible: boolean = true) {
        this.triggerToastPopup('success', message, headline, isDismissible);
    }

    public warningToastPopup(message: string, headline: string = '', isDismissible: boolean = true) {
        this.triggerToastPopup('warning', message, headline, isDismissible);
    }

    public dangerToastPopup(message: string, headline: string = '', isDismissible: boolean = true) {
        this.triggerToastPopup('danger', message, headline, isDismissible);
    }

    public makeFullScreen() {
        const data = { action: 'eIn_fullscreen', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    public showLoader() {
        const data = { action: 'eIn_Loader_On', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    public hideLoader() {
        const data = { action: 'eIn_Loader_Off', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    public scrollToTop() {
        const data = { action: 'eIn_Scroll_Top', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    public submitAudienceSelected(audID: number) {
        const audience = {
            audienceID: audID
        };
        const data = { action: 'eIn_AudienceSelected', value: audience };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    public redirectToProject(projectID: number) {
        const data = { action: 'eIn_OpenProject', value: projectID };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }

    private triggerToastPopup(type: string, message: string, headline: string, isDismissible: boolean) {
        console.log('ToastPopup ', { type, message, headline });
        const data = {
            action: 'eIn_alert_message',
            value: {
                headline,
                message,
                type,
                isDismissible
            },
        };
        this.iframeParentCommnuicationService.SendMessageToParent(data);
    }
}
